module.exports = __webpack_public_path__ + "img/cc20d89.jpg";